/* Gift card page (sections/noorns-giftcard.liquid). 2026-10-21.
   Amount: quick-pick buttons and the select both drive the one variant id the form posts.
   Recipient: the fields are enabled only when "Straight to them" is chosen, so a buyer who keeps the
   card gets it themselves. Send on is limited to today .. today + 90 days, and __shopify_offset carries
   the buyer's time zone, as Horizon's gift-card-recipient-form.js does. */
(function () {
  var root = document.getElementById('noorns-giftcard');
  if (!root) return;
  var form = document.getElementById('ngc-form');
  var select = document.getElementById('ngc-variant');
  var pills = root.querySelectorAll('.ngc-pill');
  var price = document.getElementById('product-price');

  function show(id) {
    select.value = id;
    var opt = select.options[select.selectedIndex];
    if (opt && price) price.textContent = opt.getAttribute('data-price');
    pills.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-variant') === id ? 'true' : 'false'); });
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', id);
      history.replaceState(null, '', u.toString());
    } catch (e) {}
  }
  pills.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-variant')); }); });
  select.addEventListener('change', function () { show(select.value); });

  // gallery thumbs
  var main = document.getElementById('product-image');
  root.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!main) return;
      main.src = t.getAttribute('data-src');
      main.srcset = t.getAttribute('data-srcset');
      main.alt = t.getAttribute('data-alt') || '';
      root.querySelectorAll('.thumb').forEach(function (x) { x.removeAttribute('aria-current'); });
      t.setAttribute('aria-current', 'true');
    });
  });

  // recipient
  var fields = document.getElementById('recipient-fields');
  var inputs = fields.querySelectorAll('input, textarea');
  var email = document.getElementById('ngc-email');
  var emailErr = document.getElementById('ngc-email-error');
  var date = document.getElementById('ngc-date');
  var dateErr = document.getElementById('ngc-date-error');
  var offset = document.getElementById('ngc-offset');
  var msg = document.getElementById('ngc-message');
  var count = document.querySelector('#ngc-count span');

  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  var today = new Date();
  var last = new Date(); last.setDate(last.getDate() + 90);
  date.min = iso(today);
  date.max = iso(last);

  function setMode(toThem) {
    fields.hidden = !toThem;
    inputs.forEach(function (i) { i.disabled = !toThem; });
    if (toThem) offset.value = String(new Date().getTimezoneOffset());
    else { emailErr.hidden = true; dateErr.hidden = true; email.removeAttribute('aria-invalid'); date.removeAttribute('aria-invalid'); }
  }
  root.querySelectorAll('input[name="ngc-send"]').forEach(function (r) {
    r.addEventListener('change', function () { setMode(r.value === 'recipient' && r.checked); if (r.value === 'recipient' && r.checked) email.focus(); });
  });
  msg.addEventListener('input', function () { count.textContent = String(msg.value.length); });

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function checkEmail() {
    var bad = !EMAIL.test(email.value.trim());
    emailErr.hidden = !bad;
    if (bad) email.setAttribute('aria-invalid', 'true'); else email.removeAttribute('aria-invalid');
    return !bad;
  }
  function checkDate() {
    var v = date.value;
    var bad = v !== '' && (v < date.min || v > date.max);
    dateErr.hidden = !bad;
    if (bad) date.setAttribute('aria-invalid', 'true'); else date.removeAttribute('aria-invalid');
    return !bad;
  }
  email.addEventListener('blur', function () { if (email.value) checkEmail(); });
  date.addEventListener('change', checkDate);

  form.addEventListener('submit', function (e) {
    if (fields.hidden) return;
    var ok = checkEmail();
    ok = checkDate() && ok;
    if (!ok) {
      e.preventDefault();
      e.stopImmediatePropagation();
      (email.getAttribute('aria-invalid') ? email : date).focus();
    }
  }, true);
})();
